import * as React from "react";
import {useEffect, useState} from "react";
import {IReduxState} from "reducers";
import {RouteComponentProps} from "react-router-dom";
import {connect} from "react-redux";
import ShubhForm from "shubhform";
import {
    DocUploadModes,
    getProfileValueForInputField,
    getValueForUserInput,
    handleFormValidation,
    inputFieldStyles,
    RequiredFields,
} from "loan-application/utils";
import ContainerBox from "myshubhlife-component/container-box";
import {COLOR, INPUT_TYPE} from "utils/variables";
import {ICompletedCategory, ILoanApplicationInputField} from "loan-application/interface";
import Button from "myshubhlife-component/button";
import Loading from "components/loading";
import Toast from "components/toast";
import {unflatten} from "utils";
import {saveLamProfile} from "profile/api";
import {markCategoryComplete, setApplicationIndex, updateApplicationFieldInfo} from "loan-application/actions";
import {clearDocUploadError, uploadKYCDocument} from "documents/actions";
import {getContentType} from "userform/utils";
import {indexPath, routePaths} from "loan-application/routes";
import {AndroidApis} from "app";
import DocUploadComposer from "loan-application/application/doc-upload/index";
import {GetEventDetails} from "loan-application/application/events";
import KycIndex from "Kyc";
import {clearKycStates, setKycInvoker, setProductCode} from "Kyc/action";
import {KycInvoker} from "Kyc/utils";
import {IState as IKycState} from "Kyc/reducer";
import {getRequestExternal} from "utils/externalApiCalls";
import {IProfile} from "StateInterface";
import "./styles.scss";
interface IConnectProps {
    dispatch?: (action: any) => void;
    applicationFields: object;
    userId: number;
    fieldsKey: string[];
    isAndroid: boolean;
    documents: any;
    apiVersion: number;
    applicationIndex: number;
    kyc: IKycState;
    selectedLoanProduct: string;
    completedCategory: ICompletedCategory[];
    profileDetails: IProfile;
}

interface IBankDetails {
    BANK: string;
    CITY: string;
    STATE: string;
    BRANCH: string;
}

export enum docErrors {
    S3_LIMIT = "Looks like you have already used maximum trials to upload documents. Please contact support@myshubhlife.com for further support",
    DEFAULT = "Something went wrong!",
}
const DisableFields = [
    "mobile",
];
const UserInputForm = (props: IConnectProps & RouteComponentProps) => {
    const [selectedFieldIndex, updateSelectedField] = useState(props.location['state'] ? props.location['state']['index'] : props.applicationIndex);
    const [fieldDetails, updateFieldDetails] = useState({});
    const [inputErrors, updateInputErrors] = useState({inputErrors: null});
    const [isLoaderActive , setLoader] = useState(false);
    const [toastMsg , setToastMessage] = useState<{bgColor: string, msg: string}>({bgColor: "", msg: ""});
    const [bankDetails, updateBankDetails] = useState<IBankDetails>(null);
    const [isInValidIfsc, setIsInvalidIfsc] = useState(false);
    const [showContinueBtn , setShowContinueBtn] = useState(true);
    useEffect(() => {
        window.scrollTo(0, 0);
        if (props.isAndroid) {
            AndroidApis.toolBarConfig({visibility: true, title: props.fieldsKey[selectedFieldIndex]});
        }
        updateFieldDetails({});
        if (props.fieldsKey[selectedFieldIndex] === RequiredFields.KYC) {
            props.dispatch(setKycInvoker(KycInvoker.LOAN_APPLICATION));
            props.dispatch(setProductCode(props.selectedLoanProduct));
            setShowContinueBtn(props.completedCategory.some((cat) => cat.categoryName === RequiredFields.KYC && cat.isCategoryCompleted));
        }
        return () => {
            if (props.documents.docUploadError) {
                props.dispatch(clearDocUploadError());
            }
        };
    }, [selectedFieldIndex]);
    useEffect(() => {
        if (props.kyc.completed && props.kyc.invoker === KycInvoker.LOAN_APPLICATION) {
            props.dispatch(markCategoryComplete(true, selectedFieldIndex));
            props.history.replace({ pathname: `${indexPath}${routePaths.APPLICATION}`});
            props.dispatch(clearKycStates());
        }
    }, [props.kyc.completed]);
    useEffect(() => {
        if (props.documents.docUploadError) {
            const {docType, error} = props.documents.docUploadError;
            updateInputErrors((prevState: any) => ({
                ...prevState,
                inputErrors: {
                    [docType]: docErrors.hasOwnProperty(error) ? docErrors[error] : docErrors.DEFAULT,
                },
            }));
        }
    }, [props.documents]);
    const getIfscDetails = async (ifsc: string, name: string) => {
        try {
            const ifscResponse = await getRequestExternal(`https://ifsc.razorpay.com/${ifsc}`, null);
            if (ifscResponse) {
                const ifscDetails: IBankDetails = JSON.parse(String(ifscResponse));
                updateBankDetails({
                    BANK: ifscDetails.BANK,
                    CITY: ifscDetails.CITY,
                    STATE: ifscDetails.STATE,
                    BRANCH: ifscDetails.BRANCH,
                });
                setIsInvalidIfsc(false);
            }
        } catch (error) {
            if (error.status === 404) {
                setIsInvalidIfsc(true);
            }
            updateBankDetails(null);
        }
    };
    const handleChange = (currentValues) => {
        if (inputErrors.inputErrors && inputErrors.inputErrors[currentValues.name]) {
            const {[currentValues.name]: removedValue, ...newErrorObj} = inputErrors.inputErrors;
            updateInputErrors({
                ...inputErrors,
                inputErrors: newErrorObj,
            });
        }
        if (currentValues.inputType === "file") {
            const fileType = getContentType(currentValues.value);
            const uploadDocBody = {
                imageB64: currentValues.value,
                userId: props.userId,
                docMode: DocUploadModes.SCAN_UPLOAD,
                docType: currentValues.name,
                contentType: fileType.mime,
            }
            props.dispatch(uploadKYCDocument(currentValues.name, uploadDocBody));
        }
        if (currentValues.name) {
            updateFieldDetails((prevState: any) => {
                return {
                    ...prevState,
                    [currentValues.name]: {
                        regex: currentValues.regex,
                        value: currentValues.value.trim(),
                        type: currentValues.inputType,
                    },
                };
            });
        }

        if (currentValues.name === "bankAccounts:0:ifsc" && new RegExp(currentValues.regex).test(currentValues.value)) {
            getIfscDetails(currentValues.value, currentValues.name);
        }
        return currentValues;
    };

    const moveToNextSegment = () => {
        props.dispatch(markCategoryComplete(true, selectedFieldIndex));
        if (selectedFieldIndex !== props.fieldsKey.length - 1 ) {
            updateSelectedField(selectedFieldIndex + 1);
            props.dispatch(setApplicationIndex(selectedFieldIndex + 1));
        } else {
            props.history.replace({ pathname: `${indexPath}${routePaths.APPLICATION}`});
        }
    };
    const handleSubmit = (fieldMainCategory: string) => {
        if ((props.fieldsKey[selectedFieldIndex] === RequiredFields.KYC)) {
            moveToNextSegment();
            return;
        }
        const selectedFieldDetails = props.applicationFields[fieldMainCategory][props.fieldsKey[selectedFieldIndex]];
        const validation = handleFormValidation(fieldDetails, selectedFieldDetails, props.documents.documents, props.profileDetails);
        updateInputErrors((prevState: any) => (
            {
                ...prevState,
                inputErrors: validation && validation.errors,
            }
        ));
        if (isInValidIfsc && validation.status) {
            validation.status = false;
            updateInputErrors((prevState) => (
                {
                    ...prevState,
                    inputErrors: {
                        ["bankAccounts:0:ifsc"]: "Invalid IFSC code",
                    },
                }
            ));
        }
        const fieldsToBeSend = {};
        Object.keys(selectedFieldDetails).forEach((key) => {
            selectedFieldDetails[key].forEach((field) => {
                if (field.type !== INPUT_TYPE.FILE) {
                    fieldsToBeSend[field.identifier] = getValueForUserInput(field.value, field.type);
                }
            });
        });
        Object.keys(fieldDetails).forEach((field) => {
            if (fieldDetails[field].type !== INPUT_TYPE.FILE) {
                fieldsToBeSend[field] = getValueForUserInput(fieldDetails[field].value, fieldDetails[field].type);
            }
        });
        if (validation && validation.status) {
            if (Object.keys(fieldsToBeSend).length > 0) {
                const profileObj = unflatten(fieldsToBeSend);
                const eventDetails = GetEventDetails(props.fieldsKey[selectedFieldIndex], profileObj);
                setLoader(true);
                saveLamProfile(props.userId, profileObj, null, null).then((response) => {
                    if (response.status === 200) {
                        Object.keys(selectedFieldDetails).forEach((subField) => {
                            selectedFieldDetails[subField].forEach(field => {
                                Object.keys(fieldsToBeSend).forEach( i => {
                                    if(field.identifier === i) {
                                        field['value'] = fieldsToBeSend[i];
                                    }
                                })
                            });
                        });
                        props.dispatch(updateApplicationFieldInfo(props.fieldsKey[selectedFieldIndex],selectedFieldDetails));
                        setToastMessage({bgColor: COLOR.GREEN, msg: "Profile Updated"});
                        setLoader(false);
                        moveToNextSegment();
                    }
                }).catch((err) => {
                    setLoader(false);
                    setToastMessage({bgColor: COLOR.RED, msg: "Something went wrong!"});
                });
            } else {
                moveToNextSegment();
            }
        }
    };
    const clearToastMessage = () => {
        setToastMessage({bgColor: "", msg: ""});
    };
    const docHandleChange = (name, value) => {
        if (name && value) {
            const uploadDocbody = {
                contentType: getContentType(value).mime,
                userId: props.userId,
                docMode: DocUploadModes.SCAN_UPLOAD,
                docType: name,
                imageB64: value
            }
            props.dispatch(uploadKYCDocument(name, uploadDocbody));
        }
        if (name) {
            if (inputErrors.inputErrors && inputErrors.inputErrors[name]) {
                const {[name]: removedValue, ...newErrorObj} = inputErrors.inputErrors;
                updateInputErrors({
                    ...inputErrors,
                    inputErrors: newErrorObj,
                });
            }
        }
    };

    return (
        <ContainerBox pageTitle={props.fieldsKey[selectedFieldIndex] !== "KYC" && !props.isAndroid ? props.fieldsKey[selectedFieldIndex] : ''} showBackButton={!props.isAndroid}
            backgroundColor={COLOR.WHITE}
        >
            <Loading active={isLoaderActive || props.documents.active} />
            {
                Object.keys(props.applicationFields.required_fields[props.fieldsKey[selectedFieldIndex]])
                    .map((value, key) => {
                        if (value.includes("Document")) {
                            const fields =
                                props.applicationFields.required_fields[props.fieldsKey[selectedFieldIndex]][value];
                            const docList = fields.map((name) => name.identifier);
                            return <DocUploadComposer
                                key={key}
                                label={value}
                                identifier={docList}
                                errorMsg={inputErrors.inputErrors}
                                uploaded={props.documents.documents.length > 0 &&
                                props.documents.documents.map((doc) => doc.type)}
                                handleChange={docHandleChange}
                                isAndroid={props.isAndroid}
                            />;
                        } else if (value === RequiredFields.KYC) {
                            return <KycIndex key={key} {...props}/>;
                        } else {
                            return <ShubhForm
                                key={key}
                                fields={
                                    getFieldsForUserInput(
                                        props.applicationFields.required_fields[props.fieldsKey[selectedFieldIndex]][value],
                                    )
                                }
                                onSubmit={() => handleSubmit("required_fields")}
                                onChangeHook={handleChange}
                                customStyles={inputFieldStyles()}
                                headerTitle={value}
                                hideDefaultSubmit={true}
                                errors={inputErrors}
                                successfulyUploaded={props.documents.documents.length > 0 &&
                                props.documents.documents.map((item) => item.type)}
                            />;
                        }
                    })
            }
            {
                bankDetails && props.fieldsKey[selectedFieldIndex] === RequiredFields.BANK_DETAILS &&
                <div className="bank-info-wrapper">
                    {
                        Object.keys(bankDetails).map((key) => (
                            <div className="bank-details" key={key}>
                                {`${key}:  ${bankDetails[key]}`}
                            </div>),
                        )
                    }
                </div>
            }
            {
                props.fieldsKey[selectedFieldIndex] === RequiredFields.BANK_DETAILS &&
                <div className="additional-text">
                    Note: Please enter your bank account details in which your monthly income is credited.
                </div>
            }
            {
                showContinueBtn &&
                <div className="btn-continue">
                    <Button
                        buttonText={"Continue"}
                        onClick={() => handleSubmit("required_fields")}
                        width={"100%"}
                        maxWidth={500}
                        rounded={true}
                    />
                </div>
            }
            <Toast hideToast={clearToastMessage} toastDetails={toastMsg} />
        </ContainerBox>
    );
};

const getFieldsForUserInput = (field: ILoanApplicationInputField[]) => {
    return field.map((inputDetails) => {
        const type = inputDetails.type && inputDetails.type.toLowerCase();
        return {
            inputType: type,
            label: inputDetails.label,
            name: inputDetails.identifier,
            ...(DisableFields.includes(inputDetails.identifier) && inputDetails.value) ? {disabled: true} : {},
            value: inputDetails.hasOwnProperty("value") && (inputDetails.value !== null || inputDetails.value !== undefined) ? getProfileValueForInputField(inputDetails.value, type) : "",
            options: inputDetails.options ? inputDetails.options : null,
            regex: inputDetails.regex ? inputDetails.regex : null,
            min: inputDetails.min_val ? inputDetails.min_val : null,
            max: inputDetails.max_val ? inputDetails.max_val : null,
            max_length: inputDetails.max_length ? inputDetails.max_length : null,
        };
    });
};

const mapStateToProps = (state: IReduxState): IConnectProps => {
    return {
        userId: state.login.auth.userId,
        applicationFields: state.loanApplication.applicationFields,
        fieldsKey: state.loanApplication.requiredFieldsKey,
        isAndroid: state.login.isAndroid,
        documents: state.documents,
        apiVersion: state.login.apiVersion,
        applicationIndex: state.loanApplication.applicationIndex,
        selectedLoanProduct: state.loanApplication.selectedLoanProduct,
        kyc: state.kyc,
        completedCategory: state.loanApplication.completedCategory,
        profileDetails: state.profileInfo.profile,
    };
};

export default connect<IConnectProps, {}, {}>(mapStateToProps)(UserInputForm);
